export default __webpack_public_path__ + "static/media/mockup-explore.f0350fd8.png";